import { lazy, type ComponentType, type LazyExoticComponent } from "react";

const RELOAD_KEY = "chunk-reload-ts";
const RELOAD_COOLDOWN_MS = 30_000;

function isChunkLoadError(err: unknown): boolean {
  const message = (err as { message?: string })?.message ?? "";
  return (
    message.includes("Failed to fetch dynamically imported module") ||
    message.includes("Importing a module script failed") ||
    message.includes("error loading dynamically imported module") ||
    message.includes("Loading chunk")
  );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- matches React.lazy's own generic constraint (ComponentType<any>); no narrower bound is possible for a generic pass-through wrapper.
export function lazyWithReload<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>,
): LazyExoticComponent<T> {
  return lazy<T>(async () => {
    try {
      return await factory();
    } catch (err) {
      if (!isChunkLoadError(err)) throw err;
      const last = Number(sessionStorage.getItem(RELOAD_KEY) ?? 0);
      if (Date.now() - last < RELOAD_COOLDOWN_MS) throw err;
      sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
      window.location.reload();
      return new Promise<never>(() => { /* reload in flight */ });
    }
  });
}
